module.exports = __webpack_public_path__ + "img/icon-letter-e.605e9e11.svg";